import React, { useEffect, useState } from 'react'
import './styles.scss'

export const FullScreenModal = ({ isOpen, onClose, children, headerContent }) => {
  console.log('headerContent:', headerContent)
  const [modalSize, setModalSize] = useState({ width: '80%', height: '90%' })
  const [isDragging, setIsDragging] = useState(false)
  const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 })
  const [startPosition, setStartPosition] = useState({ x: 0, y: 0 })
  const [isMinimized, setIsMinimized] = useState(false)

  const calculateSize = () => {
    const width = window.innerWidth * 0.8
    const height = window.innerHeight * 0.9
    setModalSize({ width: `${width}px`, height: `${height}px` })
  }

  useEffect(() => {
    calculateSize()
    window.addEventListener('resize', calculateSize)
    return () => window.removeEventListener('resize', calculateSize)
  }, [])

  const handleMouseDown = (e) => {
    if (!isMinimized) {
      setIsDragging(true)
      setStartPosition({ x: e.clientX - modalPosition.x, y: e.clientY - modalPosition.y })
    }
  }

  const handleMouseMove = (e) => {
    if (isDragging && !isMinimized) {
      setModalPosition({
        x: e.clientX - startPosition.x,
        y: e.clientY - startPosition.y,
      })
    }
  }

  const handleMouseUp = () => {
    setIsDragging(false)
  }

  const handleMinimize = () => {
    setIsMinimized(true)
  }

  if (!isOpen) return null

  return (
    <div className="modal-overlay">
      <div
        className="modal-contenta"
        style={{
          width: modalSize.width,
          height: isMinimized ? '40px' : modalSize.height,
          transform: `translate(${modalPosition.x}px, ${modalPosition.y}px)`,
        }}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
      >
        <div className="modal-title-bar" onMouseDown={handleMouseDown}>
          <div className="modal-header-content" style={{ display: 'flex', alignItems: 'center' }}>
            <span className="modal-title">Control de VM</span>
            <div className="modal-header-actions" style={{ marginLeft: '20px' }}>
              {headerContent || <span>No header content</span>}
            </div>
          </div>
          <div className="modal-buttons">
            <button className="modal-minimize-button" onClick={handleMinimize}>
              —
            </button>
            <button className="modal-close-button" onClick={onClose}>
              X
            </button>
          </div>
        </div>

        {!isMinimized && <div className="modal-body">{children}</div>}
      </div>
    </div>
  )
}
